import { FC, useEffect } from 'react';
import { graphql, useMutation } from 'react-relay';
import serverVars from 'server-vars';

import { PageSpinner } from 'dibs-elements/exports/PageSpinner';

import {
    SET_STEP,
    SET_PROMO_CODE,
    STEP_PROMO_TOKEN_NO_PROMO_CODE,
    STEP_PROMO_TOKEN_PROMO_CODE,
    ReducerState,
    DispatchType,
} from './reducer';

import { IFramedPromoPartnershipAddToWhitelistMutation } from './__generated__/IFramedPromoPartnershipAddToWhitelistMutation.graphql';

const promoToken = serverVars.get('promoToken');

type Props = {
    state: ReducerState;
    dispatch: DispatchType;
};

const IFramedPromoPartnershipAddToWhitelist: FC<Props> = ({ state, dispatch }) => {
    const {
        formData: { userId },
    } = state;

    const [fetchPromo] = useMutation<IFramedPromoPartnershipAddToWhitelistMutation>(
        graphql`
            mutation IFramedPromoPartnershipAddToWhitelistMutation(
                $input: PromotionBuyerWhitelistRuleCustomerSelfAddInput!
            ) {
                promotionBuyerWhitelistRuleUserSelfAdd(input: $input) {
                    code
                }
            }
        `
    );

    useEffect(() => {
        fetchPromo({
            variables: {
                input: {
                    userId,
                    promoToken,
                },
            },
            onCompleted(response) {
                const fetchedPromoCode = response?.promotionBuyerWhitelistRuleUserSelfAdd?.code;
                if (fetchedPromoCode) {
                    dispatch({ type: SET_PROMO_CODE, promoCode: fetchedPromoCode });
                    dispatch({ type: SET_STEP, step: STEP_PROMO_TOKEN_PROMO_CODE });
                } else {
                    dispatch({ type: SET_STEP, step: STEP_PROMO_TOKEN_NO_PROMO_CODE });
                }
            },
            onError() {
                dispatch({ type: SET_STEP, step: STEP_PROMO_TOKEN_NO_PROMO_CODE });
            },
        });
    }, [userId, fetchPromo, dispatch]);

    return <PageSpinner />;
};

export default IFramedPromoPartnershipAddToWhitelist;
